import { lang, LANGUAGES, setLang } from "@/i18n";

export default function LanguageSwitcher({ className = "" }) {
  return (
    <div className={`inline-flex items-center rounded-full border p-0.5 text-[11px] font-semibold ${className}`} role="group" aria-label="Language" data-testid="language-switcher">
      {Object.entries(LANGUAGES).map(([code, l]) => (
        <button key={code} type="button" onClick={() => setLang(code)} title={l.label} aria-pressed={code === lang}
          className={`rounded-full px-2 py-1 transition-colors ${code === lang ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}
          data-testid={`language-${code}-btn`}>
          {l.short}
        </button>
      ))}
    </div>
  );
}
